<template>
    <div>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="img-section">
            <img v-if="preview" :src="preview">
            <img v-else-if="selectedFileValue" :src="selectedFileValue">
            <img v-else :src="defaultFileValue" class="default">
        </div>
        <input
                type="file"
                @change="onFileSelected"
                hidden
                ref="fileInput"
        >
        <button v-if="!selectedFileValue" class="btn upload-btn" @click="$refs.fileInput.click()">
      <span>
        {{translate('UploadFile')}}...
      </span>
        </button>
        <div v-else class="btn-group">
            <button @click="$refs.fileInput.click()" class="upload-btn" :class="{'disabled': disabled}"
                    :disabled="disabled">
                <b-spinner v-if="uploadSpinner" small></b-spinner>
                <span v-else>
          {{translate('UploadFile')}}...
        </span>
            </button>
            <button @click="onRemove" class="remove-btn" :class="{'disabled': disabled}" :disabled="disabled">
                <b-spinner v-if="removeSpinner" small></b-spinner>
                <span v-else>
          {{translate('RemovePhoto')}}
        </span>
            </button>
        </div>
    </div>

</template>

<script>
    import {mapActions} from 'vuex'
    import errorMixin from '@/mixins/errorMixin';
    import customModalDialog from '@/components/widgets/customModalDialog';
    import logAnalyticsEvent, {logError} from '@/helpers/analytics'

    export default {
        name: 'photoUploader',
        mixins: [errorMixin],
        components: {
            customModalDialog,
        },
        props: ['preview', 'siteUid'],
        data() {
            return {
                customModalSettings: {},

                selectedFile: null,
                selectedFileValue: this.preview || null,
                defaultFileValue: require(`@/assets/icons/ic_photo_large.svg`),
                uploadSpinner: false,
                removeSpinner: false,
                disabled: false,
                photoSize: 5 // megabytes
            }
        },
        watch: {
            uploadSpinner(val) {
                this.disabled = val
            },
            removeSpinner(val) {
                this.disabled = val
            },
            selectedFile(val) {
                if (!val) {
                    this.selectedFileValue = null;
                } else {
                    this.selectedFileValue = URL.createObjectURL(val[0])
                }
            },
        },
        methods: {

            ...mapActions({
                changeSitePhoto: 'organization/changeSitePhoto',
                deleteSitePhoto: 'organization/deleteSitePhoto'
            }),

            async onFileSelected(e) {
                this.selectedFile = e.target.files || e.dataTransfer.files;
                if (this.selectedFile[0].type != 'image/png' && this.selectedFile[0].type != 'image/jpeg') {
                    this.customModalSettings = {
                        message: this.translate('WrongFormat')
                    }
                    logError('sites_photo_upload_bad', 'wrong file format (not png/jpeg)')
                    setTimeout(() => {
                        this.selectedFile = null;
                    }, 0)
                    return
                } else if (this.selectedFile[0].size >= (this.photoSize * 1048576)) {
                    this.customModalSettings = {
                        message: this.translate('PhotoOverweight', [this.photoSize])
                    }
                    logError('sites_photo_upload_bad', `too large photo ${this.photoSize}`)
                    setTimeout(() => {
                        this.selectedFile = null;
                    }, 0)
                    return
                } else {
                    this.uploadSpinner = true
                    try {
                        const response = await this.changeSitePhoto({
                            uid_site: this.siteUid,
                            file: e.target.files[0],
                        });
                        logAnalyticsEvent(`sites_photo_upload_success`)
                        this.createImage(this.selectedFile[0]);
                    } catch (e) {
                        logError('sites_photo_upload_error', e.data.error.message || '')
                        this.showErrorModal(e.data.error.message, {
                            title: 'Error',
                            code: e.data.error.code
                        })
                    } finally {
                        this.uploadSpinner = false
                    }
                }
            },

            createImage(file) {
                let image = new Image();
                let reader = new FileReader();
                let vm = this;

                reader.onload = (e) => {
                    vm.selectedFileValue = e.target.result;
                    vm.$emit('uploaded', e.target.result)
                };
                reader.readAsDataURL(file);
            },

            onRemove() {
                this.customModalSettings = {
                    message: this.translate('RemovePhotoConfirm'),
                    onOkHandler: this.onRemoveAction,
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }

            },
            async onRemoveAction() {
                this.removeSpinner = true
                try {
                    const response = await this.deleteSitePhoto({
                        uid_site: this.siteUid,
                    });
                    logAnalyticsEvent(`sites_photo_remove_success`)
                    this.customModalSettings = {
                        icon: 'ic_allow.svg',
                        message: this.translate('RemovePhotoSuccess')
                    }
                    this.selectedFile = null
                    this.selectedFileValue = null
                    this.$emit('removed')
                } catch (e) {
                    logError('sites_photo_remove_error', e.data.error.message || '')
                    this.showErrorModal(e.data.error.message)
                } finally {
                    this.removeSpinner = false
                }
                // this.removeSpinner = true
                // setTimeout(()=>{
                //     this.removeSpinner = false
                //     this.selectedFile = null
                //     this.selectedFileValue = null
                // }, 350)
            }
        }
    }
</script>

<style scoped>
    .img-section {
        display: block;
        height: 160px;
        max-height: 160px;
        max-width: 160px;
        overflow: hidden;
        margin: 15px auto 25px;
        position: relative;
        border-radius: 50%;
        background-color: #F3F3F3;
    }

    .img-section img {
        max-height: 160px;
        min-width: 160px;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .img-section img.default {
        max-height: 80px;
        min-width: 80px;
    }

    button {
        width: 100%;
        padding: 12px;
        background: transparent;
        border: 0;
        border-radius: 4px;
        color: #2F2F2F;
        font-weight: 600;
        margin-top: 8px;
        font-size: 14px;
        line-height: 24px;
        box-shadow: 0 2px 6px 0 rgba(0,0,0,0.24);
    }

    button.disabled {
        cursor: not-allowed;
        opacity: .6;
    }

    button span {
        font-weight: 600;
    }

    .upload-btn {
        background: #2F2F2F;
        color: #fff;
    }

    .btn-group {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: repeat(2, 1fr);
    }

    .btn-group button {
        color: #fff;
        margin-top: 0;
    }

    .btn-group .upload-btn {
        background: #2F2F2F;
    }

    .btn-group .remove-btn {
        background: #F84900;
        box-shadow: none;
    }


</style>